import { POST } from "../../APiHelper/API";

export const undoDeleteLeagueAPI = (league_id, onSuccess, onError) => {
    const data = {
        id: league_id
    }

    POST('/api/v1/leagues/undo_remove', data, onSuccess, onError)
}